import { Navigate } from "react-router-dom";

// // Authentication related pages
import Login from "../pages/Authentication/Login";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import Newsletter from "../pages/Authentication/NewsLetter";
// // Dashboard
import Dashboard from "../pages/Dashboard/index";
import OtpVerify from "../pages/Authentication/OtpVerify";
import ClientAgreement from "../pages/Authentication/ClientAgreement";
import ClientOnBoarding from "../pages/Authentication/ClientOnBoarding";
import WorkerOnBoarding from "../pages/Authentication/WorkerOnBoarding";
import WorkerInterest from "../pages/Authentication/WorkerInterest";
import WorkerAgreement from "../pages/Authentication/WorkerAgreement";
import WorkerEngagementAgreement from "../pages/Authentication/WorkerEngagementAgreement";
import UserList from "../pages/user/user-list";
import SubAdminList from "../pages/user/sub-admin-list";
import AuditLogsList from "../pages/audit-logs";
import WorkerDetails from "../pages/user/user-details-worker";
import WorkerMiniProfilePage from "../pages/user/worker-mini-profile";
import UserDetailsClient from "../pages/user/user-details-client";
import NewsLetterAll from "../pages/news-letter";
import SectorList from "../pages/sector/sector-list";
import ClientPandadocs from "../pages/client-pandadocs";
import ContactUsList from "../pages/contact-us/contact-us-list";
import ContactUs from "../pages/contact-us/create";
import VerifyOtpForgotPwd from "../pages/Authentication/VerifyOtpForgotPwd";
import ResetPassword from "../pages/Authentication/ResetPassword";
import ClientUpdate from "../pages/update-profile/client-profile";
import WorkerProfile from "../pages/update-profile/worker-profile";
import SubAdminProfile from "../pages/update-profile/sub-admin-profile";
import SettingsPrices from "../pages/settings";
import BookingCreate from "../pages/booking";
import BookingUpdate from "../pages/booking/update";
import PendingConfirmation from "../pages/pending-confirmation";
import BookingReview from "../pages/booking-review";
import CertList from "../pages/certs/cert-list";
import CourseList from "../pages/courses/course-list";
import NotificationList from "../pages/notifications/notification-list/index";
import DiscountList from "../pages/discounts/discount-list";
import BookingList from "../pages/booking/booking-list";
import WorkerBookings from "../pages/worker-bookings";
import WorkerBookingRequestDetails from "../pages/worker-bookings/request-details";
import WorkerLeaveRequests from "../pages/worker-leave-requests";
import WorkerDashboard from "../pages/worker-dashboard";
import WorkerSettings from "../pages/worker-settings";
import ClientDashboard from "../pages/client-dashboard";
import ClientSettings from "../pages/client-settings";
import ClientRoleRateCards, {
  WorkerRoleRateCards,
} from "../pages/client-role-rate-cards";
import ClientCommercialDocuments from "../pages/client-commercial-documents";
import ClientBookings from "../pages/client-bookings";
import ClientBookingDetails from "../pages/client-bookings/details";
import ClientBookingPaymentMethod from "../pages/client-bookings/pay-invoice";
import ClientBookingPaymentSuccess from "../pages/client-bookings/payment-success";
import ClientInviteWorkers from "../pages/client-bookings/invite-workers";
import ClientBookingWorkersManagement from "../pages/client-bookings/workers-management";
import ClientFindReplacements from "../pages/client-bookings/find-replacements";
import ClientSupervisors from "../pages/client-supervisors";
import ClientPayments from "../pages/client-payments";
import LeaveRequests from "../pages/leave-requests";
import UpskillingList from "../pages/upskilling/upskilling-list";
// import UpskillingNew from "../pages/upskilling/upskilling-new";
// import UpskillingDetail from "../pages/upskilling/upskilling-detail";
// import UpskillingAdminList from "../pages/upskilling-admin/list";
import AdminRefundList from "../pages/refund-admin/list";

const adminRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
  { path: "/user/list", exact: true, component: <UserList /> },
  { path: "/booking/list", exact: true, component: <BookingList /> },
  { path: "/sub-admin-list", exact: true, component: <SubAdminList /> },
  { path: "/audit-logs", exact: true, component: <AuditLogsList /> },
  {
    path: "/user/user-details/worker/:slug",
    exact: true,
    component: <WorkerDetails />,
  },
  {
    path: "/user/worker-mini-profile/:slug",
    exact: true,
    component: <WorkerMiniProfilePage />,
  },
  {
    path: "/user/user-details/client/:slug",
    exact: true,
    component: <UserDetailsClient />,
  },
  { path: "/news-letter-all", exact: true, component: <NewsLetterAll /> },
  { path: "/sector/sector-list", exact: true, component: <SectorList /> },
  { path: "/contact-us-list", exact: true, component: <ContactUsList /> },
  { path: "/cert-list", exact: true, component: <CertList /> },
  { path: "/courses/list", exact: true, component: <CourseList /> },
  { path: "/discounts/list", exact: true, component: <DiscountList /> },
  {
    path: "/notifications/list",
    exact: true,
    component: <NotificationList />,
  },
  { path: "/settings", exact: true, component: <SettingsPrices /> },
  { path: "/create-booking", exact: true, component: <BookingCreate /> },
  {
    path: "/pending-confirmation",
    exact: true,
    component: <PendingConfirmation />,
  },
  {
    path: "/booking-review/:bookingSlug",
    exact: true,
    component: <BookingReview />,
  },
  { path: "/leave-requests", exact: true, component: <LeaveRequests /> },
  // Upskilling admin reviews — temporarily disabled
  // {
  //   path: "/upskilling-admin",
  //   exact: true,
  //   component: <UpskillingAdminList />,
  // },
  {
    path: "/refund-requests",
    exact: true,
    component: <AdminRefundList />,
  },
];

// Sub-admin routes: same as admin routes but without the sub-admin-list route
const SUB_ADMIN_EXCLUDED_PATHS = ["/sub-admin-list", "/discounts/list"];

const subAdminRoutes = [
  ...adminRoutes.filter(
    (route) => !SUB_ADMIN_EXCLUDED_PATHS.includes(route.path)
  ),
  { path: "/user/me", exact: true, component: <SubAdminProfile /> },
];

const clientRoutes = [
  { path: "/dashboard", component: <ClientDashboard /> },
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
  { path: "/client-pandadocs", exact: true, component: <ClientPandadocs /> },
  { path: "/contact-us", exact: true, component: <ContactUs /> },
  { path: "/user/me", exact: true, component: <ClientUpdate /> },
  { path: "/client/settings", exact: true, component: <ClientSettings /> },
  {
    path: "/client/role-rate-cards",
    exact: true,
    component: <ClientRoleRateCards />,
  },
  {
    path: "/client/commercial-documents",
    exact: true,
    component: <ClientCommercialDocuments />,
  },
  { path: "/create-booking", exact: true, component: <BookingCreate /> },
  { path: "/client/bookings", exact: true, component: <ClientBookings /> },
  {
    path: "/client/bookings/:slug/payment",
    exact: true,
    component: <ClientBookingPaymentMethod />,
  },
  {
    path: "/client/bookings/:slug/payment-success",
    exact: true,
    component: <ClientBookingPaymentSuccess />,
  },
  {
    path: "/client/bookings/:bookingSlug/invite-workers",
    exact: true,
    component: <ClientInviteWorkers />,
  },
  {
    path: "/client/bookings/:bookingSlug/find-replacements",
    exact: true,
    component: <ClientFindReplacements />,
  },
  {
    path: "/client/bookings/:bookingSlug/workers-management",
    exact: true,
    component: <ClientBookingWorkersManagement />,
  },
  {
    path: "/client/bookings/:bookingSlug",
    exact: true,
    component: <ClientBookingDetails />,
  },
  {
    path: "/client/bookings/update/:bookingSlug",
    exact: true,
    component: <BookingUpdate />,
  },
  {
    path: "/client/supervisors",
    exact: true,
    component: <ClientSupervisors />,
  },
  {
    path: "/client/payments",
    exact: true,
    component: <ClientPayments />,
  },
];

const workerRoutes = [
  { path: "/dashboard", component: <WorkerDashboard /> },

  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
  { path: "/contact-us", exact: true, component: <ContactUs /> },
  {
    path: "/notifications/list",
    exact: true,
    component: <NotificationList />,
  },
  { path: "/user/me", exact: true, component: <WorkerProfile /> },
  { path: "/worker/settings", exact: true, component: <WorkerSettings /> },
  { path: "/my-assignments", exact: true, component: <WorkerBookings /> },
  {
    path: "/worker-leave-requests",
    exact: true,
    component: <WorkerLeaveRequests />,
  },
  {
    path: "/my-assignment/:requestSlug",
    exact: true,
    component: <WorkerBookingRequestDetails />,
  },
  // Upskilling create/detail — temporarily disabled
  // { path: "/upskilling/new", exact: true, component: <UpskillingNew /> },
  // {
  //   path: "/upskilling/:slug",
  //   exact: true,
  //   component: <UpskillingDetail />,
  // },
  { path: "/upskilling", exact: true, component: <UpskillingList /> },
  {
    path: "/worker/role-rate-cards",
    exact: true,
    component: <WorkerRoleRateCards />,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/login/client", component: <Login userTypeOverride="client" /> },
  { path: "/login/worker", component: <Login userTypeOverride="worker" /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/verify-otp-forgot-pwd", component: <VerifyOtpForgotPwd /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/register", component: <Register /> },
  {
    path: "/news-letter",
    component: <Navigate to="/client-interest" />,
  },
  {
    path: "/client-interest",
    component: <Newsletter />,
  },
  {
    path: "/client-onboarding",
    component: <ClientOnBoarding />,
  },
  {
    path: "/verify-otp",
    component: <OtpVerify />,
  },

  {
    path: "/client-submit-agreement",
    component: <ClientAgreement />,
  },
  {
    path: "/work-interest",
    component: <WorkerInterest />,
  },
  {
    path: "/worker-onboarding",
    component: <WorkerOnBoarding />,
  },
  {
    path: "worker-submit-agreement",
    component: <WorkerAgreement />,
  },
  {
    path: "/worker-engagement-agreement",
    component: <WorkerEngagementAgreement />,
  },
];

export {
  adminRoutes,
  subAdminRoutes,
  clientRoutes,
  workerRoutes,
  publicRoutes,
};
